import { Typography } from 'antd';
import styled from 'styled-components';

import useColor from '@/hooks/domain/useColor';
import { getAlphaColor } from '@/styles/colors/color.utils';

import { Flex } from '../base';

type Props = {
  author: MessageAuthorT | null;
  color?: string;
};

const MAX_NAME_LEN = 2;

const ProfileBox = (props: Props) => {
  const color = useColor();
  const author = props.author;

  const getProfileName = () => {
    if (!author) return '';
    const [first, last] = author.name.split(' ');
    if (!first) return '';
    if (last) {
      return first[0].toUpperCase() + last[0].toUpperCase();
    }
    return author?.name.toUpperCase().slice(0, MAX_NAME_LEN);
  };

  if (author?.profile_url)
    return (
      <Style
        style={{
          backgroundColor: author?.type === 3 ? color.orange100 : color.gray100,
          border: `1px solid ${color.gray300}`,
        }}
      >
        <img
          src={author?.profile_url || ''}
          width="38px"
          height="38px"
          alt={author?.name}
        />
      </Style>
    );

  return (
    <Style
      style={{
        backgroundColor: props.color
          ? props.color
          : author?.type === 2
            ? color.gray300
            : getAlphaColor(color.primary100, 0.2),
      }}
    >
      <Flex className="name-wrapper" a="center" j="center">
        <Typography
          style={{
            fontSize: 12,
          }}
        >
          {author?.type === 1 ? '' : getProfileName()}
        </Typography>
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  width: 38px;
  height: 38px;
  position: relative;
  overflow: hidden;
  border-radius: 8px;

  .name-wrapper {
    width: 100%;
    height: 100%;
  }
`;

export default ProfileBox;

// background-color: ${(props) => props.theme.colors.gray5};
// ${({ isUser }) =>
//   isUser &&
//   css`
//     background-color: ${(props) => props.theme.colors.orange100};
//   `}
